import {
  Partner,
  akademikernePartners,
} from "Store/partners/partnerInterfaces";

import { Cart } from "Store/cart/cartInterfaces";
import { getCartPartner } from "Utils/cartUtils";
import { isDefined } from "Utils/functions";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagPartner } from "Utils/unleash/flags";

export const usePartnerToggle = (cart: Cart | null): boolean => {
  const partnerAKA = useUnleashFeatureFlag(
    FeatureFlagPartner.EDIT_PRODUCT_PARTNER_AKA,
  );
  const partnerCOOP = useUnleashFeatureFlag(
    FeatureFlagPartner.EDIT_PRODUCT_PARTNER_COOP,
  );
  const partnerDANSKEBANK = useUnleashFeatureFlag(
    FeatureFlagPartner.EDIT_PRODUCT_PARTNER_DANSKE_BANK,
  );
  const partnerHUSEIERNE = useUnleashFeatureFlag(
    FeatureFlagPartner.EDIT_PRODUCT_PARTNER_HUSEIERNE,
  );

  const partnerToggles: Record<string, boolean> = {
    aka: partnerAKA,
    [Partner.COOP]: partnerCOOP,
    [Partner.DANSKE_BANK]: partnerDANSKEBANK,
    [Partner.HUSEIERNE]: partnerHUSEIERNE,
  };

  const cartPartner = cart !== null ? getCartPartner(cart) : undefined;
  if (!isDefined(cartPartner)) {
    return false;
  }

  let partnerToggleToCheck: string = cartPartner;
  if (akademikernePartners.includes(cartPartner)) {
    partnerToggleToCheck = "aka";
  }

  return !!partnerToggles[partnerToggleToCheck];
};
